export default __webpack_public_path__ + "static/media/whiteIcon.8749662c.jpeg";